import React from "react";

export const GraphSolidSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 25 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.3001 5L19.8001 6V6.5V17L19.8001 19H17.8001H7.80008H5.80008V17V11.5001L5.80002 11.5L11.3001 6L12.8001 7.5L14.3001 9L17.8001 5.5L18.3001 5Z"
      ></path>
    </svg>
  );
};
